import { Component, OnInit, ViewEncapsulation, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import { MsalService } from '@azure/msal-angular';
import { AboutComponent } from '../about/about.component';
import { Globals } from '../models/globals.model';
import { GlobalService } from '../services/global.service';
import { ThemeService } from '../services/theme.service';
import { notification } from '../models/interfaces/notifications';
/*NOSONAR
//import { NotificationService } from '../services/notification-service';
//import { AlertComponent } from '../common/alert/alert.component';
//import { NotificationComponent } from '../notification/notification.component';
*/
import { MLService } from '../services/ml-service';
import { Tenant } from '../models/tenant.model';
import { TenantService } from '../services/tenant.service';
import { Refinery } from '../models/refinery.model';
import { concatMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavBarComponent implements OnInit {
  userName: string;
  userShortName: string;
  notification: notification[] = [];
  unreadNotifications: number = 0;
  rbacName: string = '';
  countryCode: any;
  countryList: any;
  releaseDetails: any;
  /*NOSONAR
  //zeroNotification = false;
  //errorNotification = false;
  //notificationLimit = 10;
  //hideNotificationNumber = false;
  */
  dateString: string;
  tenantList: Tenant[];
  tenantName: string;
  tenantId: number;
  refineryName: string;
  refineryList: string[];
  refinerytMap: Refinery[];
  public destroyed = new Subject<any>();
  @Input() data: string;

  constructor(private readonly authService: MsalService, public mlServie: MLService,
    public dialog: MatDialog, public globals: Globals, public globalService: GlobalService,
    /*NOSONAR
    public notificationService: NotificationService,
    */
    private readonly tenantService: TenantService,
    public themeService: ThemeService, public _router: Router,
    public route: ActivatedRoute) {
    this.countryList = [
      {
        'Id': 1,
        'Name': 'English',
        'Code': 'EN',
      }
    ];
  }
  ngOnInit() {
    this.themeService.setDarkTheme();
    this.getReleaseDetails();
    this.countryCode = 'EN';
    $('#handberg').click(function () {
      $('.row-offcanvas').toggleClass('active');
      $('.collapse').toggleClass('in').toggleClass('hidden-xs').toggleClass('visible-xs');
    });
    $('#close-sidebar').click(function () {
      $('.page-wrapper').removeClass('toggled');
    });
    $('#show-sidebar').click(function () {
      $('.page-wrapper').addClass('toggled');
    });
    this.tenantService.getTenants()
      .pipe(
        takeUntil(this.destroyed),
        concatMap(async (data: Refinery[]) => {
          let item = data.filter(item => item.tenantList[0] != undefined && item.tenantList.length > 0);
          this.refineryList = item.map(a => a.refineryName);
          this.refinerytMap = item;
          this.checkActivatedTenant();
        })
      ).subscribe()

  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }
  /**
   * checks if any tenant is activated
   */
  checkActivatedTenant() {
    let tenantPopulated = false;
    this.refinerytMap.forEach(ref => {
      const selectedTenantIndex = ref.tenantList.findIndex(ten => ten.isSelected);
      if (selectedTenantIndex >= 0) {
        this.populateTenant(ref.refineryName, true, selectedTenantIndex);
        tenantPopulated = true;
      }
    });
    if (!tenantPopulated) {
      this.populateTenant(this.refineryList[0], true, 0);
    }
  }
  /**
    * Used for switching tenants and redirection to particular page
    * @param isCallFromUI to check call from UI
    */
  populateTenant(refineryName: string, isCallFromUI?: boolean, tenantIndex?: number) {
    if (this.refinerytMap && this.refinerytMap.length > 0) {
      this.refinerytMap.some((u) => {
        if (refineryName === u.refineryName) {
          this.refineryName = refineryName;
          this.tenantList = u.tenantList;
          this.tenantName = this.tenantList[tenantIndex].tenantName;
          this.onTenantChange(this.tenantList[tenantIndex], isCallFromUI);
        }
      });
    }
  }
  logout() {
    this.authService.logout();
  }
  // show about dialog for version, build date and build number
  openAboutRelease(): void {
    this.dialog.open(AboutComponent, {
        data: this.releaseDetails,
      });
    
  }
  /*NOSONAR
  //getNotification() {
  //  this.notificationService.getTopNotificationList().subscribe((data: any): void => {
  //    let notificationsList = data.Notifications;
  //    if (notificationsList && notificationsList.length > 0) {
  //      this.zeroNotification = false;
  //      this.notification = notificationsList.sort((a, b) => a.acknowledged - b.acknowledged);
  //      this.unreadNotifications = data.UnreadCount;
  //    } else if (notificationsList.length == 0) {
  //      this.unreadNotifications = 0;
  //      this.zeroNotification = true;
  //    }
  //  }, (error: Error) => {
  //    this.errorNotification = true;
  //    this.globalService.showAlert(AlertComponent, { success: false, message: 'Error getting notifications' });
  //  });
  //}

    //dropdownStatus(event) {
    //  if (event) {
    //    this.dateString = new Date().toISOString();
    //    this.hideNotificationNumber = true;
    //    this.notificationService.markReadTopNotification(this.dateString);
    //  } else {
    //    this.hideNotificationNumber = false;
    //  }
    //}
  //notificationOpen() {
  //  this.hideNotificationNumber = true;
  //  this.dateString = new Date().toISOString();
  //}

  //notificationClose() {
  //  this.hideNotificationNumber = false;
  //  this.notificationService.markReadTopNotification(this.dateString);
  //}
  */
  getReleaseDetails() {
    this.releaseDetails = this.globals.releaseDetails;
  }

  selectFlag(Code: any) {
    this.countryCode = Code;
  }
  toggleTheme() {
    if (this.themeService.isDarkTheme()) {
      this.themeService.setLightTheme();
    } else {
      this.themeService.setDarkTheme();
    }
  }
  /*NOSONAR
  //showAllNotification() {
  //  this.globalService.openModelWindow(null, this, NotificationComponent, '80%', 'custom-modalbox', this.notification);
  //}

  //ngOnChanges(changes: SimpleChanges): void {
  //  if (this.globalService.isNotNull(changes.data.currentValue)) {
  //    this.getNotification();
  //  }
  //}
  */
  /**
  * Used for switching tenants and redirection to particular page
  * @param tenant tenant to be updated
  */
  onTenantChange(tenant: Tenant, isCallFromUI?: boolean) {
    this.tenantName = tenant.tenantName;
    this.tenantId = tenant.tenantId;
    this.tenantService.setCurrentTenant(tenant);
     if (isCallFromUI) {
      this._router.navigate(['flowsheet']);
  }
    /*NOSONAR
    //this.getNotification();
    */
  }
}
